import { render, staticRenderFns } from "./Design2.vue?vue&type=template&id=568ddfe6&"
import script from "./Design2.vue?vue&type=script&lang=js&"
export * from "./Design2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports